import { inject } from '@angular/core';
import { AnalyticsService } from '../services/analytics.service';
import { AnalyticsEvent } from '../events/analytics-event';

export abstract class AnalyticsEventProvider<T extends AnalyticsEvent> {
  private readonly analyticsService = inject(AnalyticsService);

  protected push(event: T): void {
    this.analyticsService.push(event);
  }
}
